import React from 'react'

import TalkToAdvisor from './TalkToAdvisor'

const App = props => {
  const { content, backgroundImage } = props.content
  return (
    <div className='break-before u-marginTop10gu u-bgColorWhite'>
      <TalkToAdvisor content={content} backgroundImage={backgroundImage} />
    </div>
  )
}

export default App
